import { render, staticRenderFns } from "./select-plan.vue?vue&type=template&id=5f83a94a&scoped=true"
import script from "./select-plan.vue?vue&type=script&lang=js"
export * from "./select-plan.vue?vue&type=script&lang=js"
import style0 from "./select-plan.vue?vue&type=style&index=0&id=5f83a94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83a94a",
  null
  
)

export default component.exports